import CollectionIcon from "@/icons/CollectionIcon";
import CheckIcon from "@/icons/CheckIcon";
import LockCloseIcon from "@/icons/LockClosedIcon";

const MODEL_BY_PATH = {
  objects: "object",
  templates: "template",
  repositories: "repository",
};

const WITHOUT_TEMPLATES = ["templates", "repositories"];

const TITLES = {
  objects: "Объекты",
  templates: "Шаблоны",
  repositories: "Справочники",
};

const MODAL_TITLES = {
  objects: "тип объекта",
  templates: "шаблон",
  repositories: "справочник",
};

const FIELDS_TITLES = {
  objects: "Поля объекта",
  templates: "Поля шаблона",
  repositories: "Поля справочника",
};

const FIELD_TYPES_OPTIONS = [
  {
    value: "float",
    label: "Дробное",
    color: "blue",
  },
  {
    value: "integer",
    label: "Целое",
    color: "geekblue",
  },
  {
    value: "money",
    label: "Деньги",
    color: "green",
  },
  {
    value: "text",
    label: "Строка",
    color: "magenta",
  },
  {
    value: "mask",
    label: "Маска",
    color: "red",
  },
  {
    value: "moment",
    label: "Момент",
    color: "purple",
  },
  {
    value: "date",
    label: "Дата",
    color: "magenta",
  },
  {
    value: "day",
    label: "День",
    color: "red",
  },
  {
    value: "month",
    label: "Месяц",
    color: "volcano",
  },
  {
    value: "year",
    label: "Год",
    color: "lime",
  },
  {
    value: "object",
    label: "Объект",
    color: "red",
  },
  {
    value: "repository",
    label: "Справочник",
    color: "cyan",
  },
  {
    value: "table",
    label: "Таблица",
    color: "blue",
  },
  {
    value: "employee",
    label: "Сотрудник",
    color: "orange",
  },
  {
    value: "point",
    label: "Точка",
    color: "geekblue",
  },
  {
    value: "polygon",
    label: "Полигон",
    color: "yellow",
  },
  {
    value: "parent_polygon",
    label: "Родительский полигон",
    color: "gold",
  },
  // {
  //   value: "rpoint",
  //   label: "Точка на рисунке",
  //   color: "magenta",
  // },
  {
    value: "image",
    label: "Изображение",
    color: "purple",
  },
  {
    value: "file",
    label: "Файл",
    color: "gold",
  },
];

const DEFINITIONS = ["object", "template", "repository"];
const NUMBER_FIELDS = ["float", "integer", "money"];
const STRING_FIELDS = ["text", "mask"];
const DATE_FIELDS = ["day", "month", "year", "moment", "date"];
const UPLOAD_FIELDS = ["file", "image"];
const MAP_FIELDS = ["point", "polygon", "parent_polygon"];
const POINTS_FIELDS = ["rpoint"];

const OBJECTS_TYPES = [
  {
    label: "Все",
    value: "all",
    icon: <CollectionIcon style={{ fontSize: 14 }} />,
  },
  {
    label: "Вы участник",
    value: "root",
    icon: <CheckIcon style={{ fontSize: 14 }} />,
  },
  {
    label: "Вы читатель",
    value: "child",
    icon: <LockCloseIcon style={{ fontSize: 14 }} />,
  },
];

const PRESETS_COLORS = [
  "#6e6e6e",
  "#0066a6",
  "#357dfb",
  "#8C5CC8",
  "#c31ee0",
  "#a70112",
  "#ef1f0c",
  "#e66a25",
  "#ffbf00",
  "#13cd06",
];
const POLYGON = [
  {
    lat: 57.10333501735761,
    lon: 36.764836152028664,
    _index: 0,
  },
  {
    lat: 57.080265816362356,
    lon: 36.77198802378828,
    _index: 1,
  },
  {
    lat: 57.05065016425621,
    lon: 36.72047327959319,
    _index: 2,
  },
  {
    lat: 57.07337152384818,
    lon: 36.645701025085714,
    _index: 3,
  },
  {
    lat: 57.10905890189591,
    lon: 36.690682534310156,
    _index: 4,
  },
];

export {
  DEFINITIONS,
  TITLES,
  MODAL_TITLES,
  FIELDS_TITLES,
  FIELD_TYPES_OPTIONS,
  MODEL_BY_PATH,
  WITHOUT_TEMPLATES,
  NUMBER_FIELDS,
  STRING_FIELDS,
  DATE_FIELDS,
  UPLOAD_FIELDS,
  MAP_FIELDS,
  POINTS_FIELDS,
  OBJECTS_TYPES,
  PRESETS_COLORS,
  POLYGON,
};
